module.exports = __webpack_public_path__ + "img/chapterImage.914be920.png";